module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon_love-ff17f3b9c9a12ce3567aefcb0dda7d55.svg";